export default class TriggerHref {
    constructor(domElement) {
        this.element = domElement;
        this.element.addEventListener('click', TriggerHref.addHref);
    }

    static addHref(event) {
        const url = event.currentTarget.querySelector('a')
            .getAttribute('href') || null;

        if(url) {
            window.location.assign(url);
        }
    }
}

